import styles from './Credential.scss'
import { withNamespaces } from 'react-i18next'

const Credential = ({ t }) => (
    <div class={styles.credential}>
        ©{' ' + t('Credential.title') + ' '}
        <a href="https://easyms.co" target="_blank">
            EasyMS.co
        </a>
    </div>
)

export default withNamespaces()(Credential)



// WEBPACK FOOTER //
// ./components/Credential/Credential.js